import { Component, OnInit, Input, ViewEncapsulation, OnDestroy } from '@angular/core';
import { TmcTableModel } from '@sdbn/common';
import { SelectionType } from '@sdbn/common';
import { ColumnType } from '@sdbn/common';
import { Row } from '@sdbn/common';
import { Subscription } from 'rxjs';
import { ColumnDefinition } from '@sdbn/common';
import { AppClientConfigurationService } from '@sdbn/common';
import { TransportFormatterService } from '../../../../../../../legacy/transport-formatter-service';
import { StationUsage } from '../../../../../../../client/model/station-usage.model';
import { TransportDetails } from '../../../../../../../components/transport-details/transport-details-model';
import { DateUtilsService, TimeUtilsService, TranslationService } from '@sdbn/common';

@Component({
  selector: 'app-waiting-area-details',
  templateUrl: './waiting-area-details.component.html',
  styleUrls: ['./waiting-area-details.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WaitingAreaDetailsComponent implements OnInit, OnDestroy {

  defaultColumnDefinitions: ColumnDefinition[];

  localTransports: TransportDetails[];

  private languageSubscription: Subscription;

  stationUsage: StationUsage;

  subscription: Subscription;

  @Input('stationUsage') set setStationUsage(stationUsage: StationUsage) {
    console.log('updating waiting area list by usage', this.stationUsage);
    this.stationUsage = stationUsage;

    this.updateTable();
    this.subscription = this.stationUsage.changed.subscribe(value => {
      this.updateTable();
    });
  }

  tableModel = new TmcTableModel();

  constructor(
    private transportFormatterService: TransportFormatterService,
    private configurationService: AppClientConfigurationService,
    private translationService: TranslationService,
    private dateUtils: DateUtilsService,
    private timeUtils: TimeUtilsService
  ) {

    this.languageSubscription = this.translationService.changed.subscribe(language => {
      if (this.localTransports) {
        this.updateTable();
      }
    });
  }


  ngOnInit() {
    this.initDefaultTableColumns();
    this.initTable();
  }

  ngOnDestroy(): void {
    if (this.languageSubscription) {
      this.languageSubscription.unsubscribe();
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private initTable() {
    this.tableModel.selectionType = SelectionType.NONE;
    this.tableModel.sortable = false;
    this.tableModel.filterable = false;
    this.tableModel.sortColumn = 'numberPlate';
    this.tableModel.sortDirection = 'asc';

    const columnProperty = this.configurationService.getPropertyValue('ui-component.station-assignment-client.waitingarea.transport.columns', null);

    if (columnProperty != null && String(columnProperty).length > 0) {

      const columProperties = String(columnProperty).split('|');
      for (const p of columProperties) {
        const def = this.findColumnDefinitionById(p);
        if (def) {
          this.tableModel.columnDefinitions.push(def);
        }
      }
    } else {
      this.tableModel.columnDefinitions.push(...this.defaultColumnDefinitions);
    }

  }

  private initDefaultTableColumns() {
    const prefix = 'tmc-yard.entity.transport.';
    this.defaultColumnDefinitions = [
      { id: 'numberPlate', name: 'number plate', visible: true, type: ColumnType.STRING, translationKey: prefix + 'numberplate' },
      { id: 'carrier', name: 'carrier', visible: true, type: ColumnType.STRING, translationKey: prefix + 'carrier' },
      { id: 'cargo', name: 'cargo', visible: true, type: ColumnType.STRING, translationKey: prefix + 'cargo' },
      { id: 'nextProcessingPosition', name: 'nextProcessingPosition', visible: true, type: ColumnType.STRING, translationKey: prefix + 'next-processing-position-name' },
      { id: 'planningDate', name: 'planningDate', visible: true, type: ColumnType.STRING, translationKey: prefix + 'planning-date' },
      { id: 'registration', name: 'registration', visible: true, type: ColumnType.STRING, translationKey: prefix + 'registration-date' },
      {
        id: 'processingTimeCurrentProcessing',
        name: 'processingTimeCurrentProcessing',
        visible: true, type: ColumnType.STRING, translationKey: prefix + 'processing-time-current-processing'
      },
      { id: 'options', name: 'options', visible: true, type: ColumnType.STRING, translationKey: prefix + 'options' },
    ];
  }

  updateTable() {

    console.log('updated table rows', this.tableModel, this.stationUsage);

    const rows: Row[] = [];
    for (const details of this.stationUsage.transports) {
      const row: Row = new Row();
      row.id = details.id + '';
      let nextPositionName = details.nextPosition?.stationName != null ? details.nextPosition.stationName : '';
      row.values = {
        carrier: details.masterdata.carrier,
        cargo: details.masterdata.firstLoadCarrier.cargo,
        nextProcessingPosition: nextPositionName,
        planningDate: details.timing.planningDate != null ? this.dateUtils.formatTimestampToDeFormat(details.timing.planningDate) : '',
        registration: details.timing.entranceDate != null ? this.dateUtils.formatTimestampToDeFormat(details.timing.entranceDate) : '',
        processingTimeCurrentProcessing: details.currentPosition?.duration != null ? this.timeUtils.formatDuration(details.currentPosition?.duration) : '',
        options: details.transportOptionMarks
      };
      row.values.numberPlate = this.transportFormatterService.formatTransportIdentifier(details.identifyingNumberplate, details.scope);
      rows.push(row);
    }

    this.tableModel.setRows(rows);

    console.log('updated table rows', this.tableModel, rows, this.stationUsage);
  }

  private findColumnDefinitionById(columnId: string) {
    for (const definition of this.defaultColumnDefinitions) {
      if (definition.id === columnId) {
        return definition;
      }
    }
    return null;
  }

  onSelectionChanged($event) {

  }
}
